/**
 * @file
 * Table sorting functionality with select dropdown for descending column sorting.
 */

(function ($) {
  'use strict';

  /**
   * Drupal behavior for table sorting functionality.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches table sorting behavior with select dropdown.
   */
  Drupal.behaviors.tableSorting = {
    attach: function (context, settings) {

      once('add-sortable-classes', 'table', context).forEach(function (table) {
        const $table = $(table);
        $table.addClass('sortable');
        $table.find('thead th').addClass('sortable');
      });


      once('table-sort', 'table.sortable', context);

      $('table.sortable').each(function (index) {
        const table = $(this);
        const headers = table.find('th.sortable');

        // Skip if no sortable headers found.
        if (headers.length === 0) {
          console.log('No sortable headers found in table');
          return;
        }

        const sortSelect = $('<select>', {
          'class': 'table-sort-select',
          'id': 'table-sort-select-' + index,
          'aria-label': Drupal.t('Sort table by column')
        });
        const sortSelectLabel = $('<label>', {
          'text': Drupal.t('Sort by'),
          'class': 'table-sort-label',
          'for': 'table-sort-select-' + index,
        });


        // Add options
        headers.each(function (index) {
          const header = $(this);
          const columnText = header.text().trim();

          sortSelect.append($('<option>', {
            value: index,
            text: Drupal.t('@column', {'@column': columnText})
          }));
        });

        // Add change event handler to select.
        sortSelect.on('change', function () {
          const columnIndex = parseInt($(this).val());

          if (!isNaN(columnIndex)) {
            const header = headers.eq(columnIndex);
            sortTableColumn(table, columnIndex, header);
          }
        });

        // Prepend select to table.
        table.before(sortSelect);
        sortSelect.before(sortSelectLabel);
      });

      //Default sort by first column
      $('.table-sort-select').val(0).change();
    }
  };

  /**
   * Sorts a table column in descending order.
   *
   * @param {jQuery} table
   *   The jQuery table element to sort.
   * @param {number} columnIndex
   *   The index of the column to sort.
   * @param {jQuery} $header
   *   The jQuery header element for the column.
   */
  function sortTableColumn(table, columnIndex, header) {
    const tbody = table.find('tbody');
    if (tbody.length === 0) {
      return;
    }

    const rows = tbody.find('tr');
    const newDirection = 'asc'; // Always sort descending as requested

    // Clear all headers' sort indicators using jQuery.
    const allHeaders = table.find('th.sortable');
    allHeaders.removeAttr('data-sort-direction')
               .removeClass('sort-asc sort-desc')
               .attr('aria-sort', 'none');

    // Set current header's sort direction using jQuery.
    header.attr('data-sort-direction', newDirection)
           .addClass('sort-' + newDirection)
           .attr('aria-sort', 'descending');

    // Convert jQuery collection to array for sorting.
    const rowsArray = rows.toArray();

    // Sort the rows in descending order.
    rowsArray.sort(function (rowA, rowB) {
      const cellA = $(rowA).find('td').eq(columnIndex)[0];
      const cellB = $(rowB).find('td').eq(columnIndex)[0];

      if (!cellA || !cellB) {
        return 0;
      }

      let textA = $(cellA).text().trim().toLowerCase();
      let textB = $(cellB).text().trim().toLowerCase();

      // Handle numeric values if they exist.
      const numA = parseFloat(textA);
      const numB = parseFloat(textB);

      if (!isNaN(numA) && !isNaN(numB)) {
        textA = numA;
        textB = numB;
      }

      let comparison = 0;
      if (textA > textB) {
        comparison = 1;
      } else if (textA < textB) {
        comparison = -1;
      }

      // Always return ascending order
      return comparison;
    });

    // Re-append sorted rows to tbody using jQuery.
    tbody.empty().append(rowsArray);

    // Trigger custom event for other scripts to listen to.
    table.trigger('drupal:tableSorted', {
      table: table[0],
      column: columnIndex,
      direction: newDirection,
      header: header[0]
    });
  }

})(jQuery);
